module.exports = __webpack_public_path__ + "static/media/identification.97cc1b8e.svg";